export default __webpack_public_path__ + "static/media/royal_design_bg.b732086a.png";